export default {
  guest: {
    earn_pts: 'Earn {{points}} pts on this order',
    tagline: 'Get rewarded. Every order, every time.',
    pick_reward: 'Pick what you want when you get there',
    free_at: 'free at {{points}} pts',
    save_at: 'save {{amount}} at {{points}} pts',
    nearest: 'nearest',
    cta: "Start earning — it's free",
    already_member: 'Already a member?',
    sign_in: 'Sign in',
  },
  member: {
    earning_free: "You're earning free food",
    every_euro_one: 'Every {{amount}} you spend = 1 pt. Redeem for free items & discounts.',
    every_euro_other: 'Every {{amount}} you spend = {{count}} pts. Redeem for free items & discounts.',
    until_redeem: '{{remaining}} pts until you can start redeeming',
    unlock_first: 'This order alone unlocks your first reward!',
    so_close: 'So close to free food!',
    just_more: 'Just {{remaining}} more pts and you can start saving.',
    pts_to_unlock: '{{remaining}} pts to unlock rewards',
    this_order_unlocks: 'This order gets you to {{points}} pts — you can redeem next order!',
    save_next: 'Save up to {{amount}} off next time',
    pts_from_order: '+{{earned}} pts from this order — only {{remaining}} left after!',
    rewards_value: '= {{amount}} in rewards',
    save_this_order: 'Save up to {{amount}} on this order',
    use_pts: 'Use your {{points}} pts at checkout',
    earned_this_order: '+{{points}} pts earned this order',
    current: 'Current',
    from_this_order: '+{{points}} from this order',
    expiration_zero: '{{points}} pts expire today',
    expiration_one: '{{points}} pts expire in 1 day',
    expiration_other: '{{points}} pts expire in {{count}} days',
  },
};
